import { useEffect, useState } from 'react';
import { db, auth } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export type Entitlement = {
  status: 'trial' | 'active' | 'expired' | 'none';
  plan?: string;
  trialEndsAt?: any;
  validUntil?: any;
};

export function useEntitlement() {
  const [entitlement, setEntitlement] = useState<Entitlement>({ status: 'none' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const uid = auth.currentUser?.uid;
    if (!uid) {
      setEntitlement({ status: 'none' });
      setLoading(false);
      return;
    }
    const ref = doc(db, 'entitlements', uid);
    const unsub = onSnapshot(ref, (snap) => {
      const data = snap.data() as any;
      if (!data) {
        setEntitlement({ status: 'none' });
        setLoading(false);
        return;
      }
      // Determine status based on timestamps
      const now = Date.now();
      const trialMs = data.trialEndsAt?.toDate?.()?.getTime?.() || (data.trialEndsAt ? new Date(data.trialEndsAt).getTime() : 0);
      const validMs = data.validUntil?.toDate?.()?.getTime?.() || (data.validUntil ? new Date(data.validUntil).getTime() : 0);
      let status: Entitlement['status'] = 'none';
      if (validMs && validMs > now) status = 'active';
      else if (trialMs && trialMs > now) status = 'trial';
      else status = 'expired';
      setEntitlement({ status, plan: data.plan, trialEndsAt: data.trialEndsAt, validUntil: data.validUntil });
      setLoading(false);
    }, () => setLoading(false));
    return unsub;
  }, [auth.currentUser?.uid]);

  return { entitlement, loading };
}















































